import React from 'react';
import { Hero } from '../components/home/Hero';
import { References } from '../components/home/References';
import { WhatIsDTech } from '../components/home/WhatIsDTech';
import { ProductShowcase } from '../components/home/ProductShowcase';
import { AvailabilityDelivery } from '../components/home/AvailabilityDelivery';
import { WhyDTechUnified } from '../components/home/WhyDTechUnified';
import { Applications } from '../components/home/Applications';
import { PromoPopup } from '../components/home/PromoPopup';
interface HomePageProps {
  onRequestQuote: (productId?: string) => void;
}
export function HomePage({
  onRequestQuote
}: HomePageProps) {
  return <main data-id="element-794">
      <PromoPopup onRequestQuote={() => onRequestQuote()} data-id="element-795" />
      <Hero onRequestQuote={() => onRequestQuote()} data-id="element-796" />
      <References data-id="element-797" />
      <WhatIsDTech data-id="element-798" />
      <ProductShowcase onRequestQuote={onRequestQuote} data-id="element-799" />
      <AvailabilityDelivery onRequestQuote={() => onRequestQuote()} data-id="element-800" />
      <WhyDTechUnified data-id="element-801" />
      <Applications data-id="element-802" />
    </main>;
}